<template>
  <div class="auth" >
   <div class="background" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"></div>
    <div class="foreground">
      <Navbar />
      <div class="content">
        <div :class="`card _shadow(1) ${$route.name !== 'sign-up' && '_m:top(4)'}`">
          <transition name="auth-transition" mode="out-in">
            <router-view />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from '@/components';
const bg = require(`@/assets/themes/${process.env.VUE_APP_THEME_NAME}/background.jpg`);

export default {
  name: 'AuthIndex',
  components: { Navbar },
  // @todo AG: if we move info and disclaimers views into a completeProfile folder,
  // then we could include the authguard here once rather than in every auth view other than above
  // mixins: [authGuard({ name: 'appIndex' })],
  data: () => ({
    backgroundImage: bg
  })
};
</script>
<style lang="less">
@import "~@/utils.less";

.auth {
  .background {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: center;
  }

  .foreground {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: absolute;
    display: flex;
    align-items: center;
    padding-bottom: calc(var(--gw) * 2.75);
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .card {
    position: absolute;
    top: 11%;
    min-width: 25rem;
    min-height: 10rem;
    z-index: 10;
    margin: 0 auto;
    padding: calc(var(--gw) * 1.5) calc(var(--gw) * 2) calc(var(--gw) * 1.5);
    padding-bottom: 3.5rem;
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    border-radius: calc(var(--border-radius) * 1.5);
    transition: all ease-in 0.25s;
    .xs-only({
      top: 3rem;
      min-width: unset;
      width: 95vw;
    });
  }

  ds-form, form {
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-weight: 500;
    margin-bottom: calc(var(--gw) * 1.6);
  }

  ds-button {
    align-self: center;
  }

  .auth-disclaimer {
    padding: var(--gw);
    min-height: 3.25rem;
    max-height: 7.5rem;
    overflow: scroll;
    color: var(--neutral-900);
    border: 1px solid var(--neutral-400);
    border-radius: var(--radius);
    margin-bottom: var(--gw);

    h2 {
      margin-bottom: calc(var(--gw) * 0.5);
    }
  }

  .auth-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: calc(var(--gw) / 3) calc(var(--gw) / 2);
    color: var(--grey-900);
    background-color: var(--grey-300);
    border-radius: 0 0 var(--border-radius) var(--border-radius);
  }
}

.auth-transition {
  &-enter-active {
    transition: max-height 0.5s, opacity 0.15s;
  }

  &-enter {
    max-height: 0;
    position: absolute;
    opacity: 0;
    // transform: translateX(20rem);
  }

  &-enter-to {
    max-height: 200vh;
    opacity: 1;
    // transform: translateX(0);
  }

  &-leave {
    max-height: 200vh;
    opacity: 1;
  }

  &-leave-to {
    max-height: 0;
    opacity: 0;
    // transform: translateX(-20rem);
  }

  &-leave-active {
    transition: max-height 0.5s, opacity 0.15s;
  }
}

</style>
